var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "open-layers-map" }, [
    _c("div", { ref: "map", staticClass: "map" }),
    _c("div", { ref: "mapTooltip", staticClass: "map-tooltip" }),
    _c(
      "div",
      { staticClass: "control-group zoom-control" },
      [
        _c(
          "cms-button",
          {
            staticClass: "zoom-in",
            attrs: { title: "Zoom in" },
            on: {
              click: function ($event) {
                return _vm.onZoomClick(1)
              },
            },
          },
          [_c("i")]
        ),
        _c("div", { staticClass: "divider" }),
        _c(
          "cms-button",
          {
            staticClass: "zoom-out",
            attrs: { title: "Zoom uit" },
            on: {
              click: function ($event) {
                return _vm.onZoomClick(-1)
              },
            },
          },
          [_c("i")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }